import {useMemo} from 'react'
import {useGetCurrentUserQuery, useGetMetersQuery, useGetStructuresQuery} from 'store/Store'
import {getDocumentId} from 'utils'

const useFormMeterReadingLogic = ({fields, methods}) => {
    const {data: user} = useGetCurrentUserQuery()
    const userAccount = useMemo(() => user?.account, [user])
    const {watch} = methods
    const {account, structure} = watch()
    const {data: structures, isLoading: isLoadingStructure} = useGetStructuresQuery(
        {account: getDocumentId(account)},
        {skip: !userAccount && !account}
    )

    const {data: meters, isLoading: isLoadingMeter} = useGetMetersQuery(
        {
            structure: getDocumentId(structure),
        },
        {skip: !structure}
    )
    if (fields.createMeterReading) {
        fields.createMeterReading.items.structure.options = structures?.data
        fields.createMeterReading.items.structure.isLoading = isLoadingStructure
        fields.createMeterReading.items.meter.options = meters?.data
        fields.createMeterReading.items.meter.isLoading = isLoadingMeter
    }

    return {fields}
}

export default useFormMeterReadingLogic
